import script from "./TreeItems.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeItems.vue?vue&type=script&setup=true&lang=js"

import "./TreeItems.vue?vue&type=style&index=0&id=0c24b32a&lang=css"

const __exports__ = script;

export default __exports__